// src/api/interceptors.js
// Configuración centralizada de la API base

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://metriciqkontrol.online';
// Gestión centralizada de tokens - MEJORADO
const TokenManager = {
	getToken: () => {
		try {
			const token = localStorage.getItem('authToken');
			//console.log('🔑 Token obtenido del localStorage:', token ? '✅ Presente' : '❌ Ausente');
			return token;
		} catch (error) {
			//console.error('❌ Error al obtener token:', error);
			return null;
		}
	},

	setToken: (token) => {
		try {
			localStorage.setItem('authToken', token);
			//console.log('💾 Token guardado en localStorage');
		} catch (error) {
			return null;
			//console.error('❌ Error al guardar token:', error);
		}
  	},

	removeToken: () => {
		try {
			localStorage.removeItem('authToken');
			localStorage.removeItem('refreshToken');
			localStorage.removeItem('user');
			//console.log('🗑️ Tokens removidos');
		} catch (error) {
			return null;
			//console.error('❌ Error al remover tokens:', error);
		}
	},

	getRefreshToken: () => {
		try {
			return localStorage.getItem('refreshToken');
		} catch (error) {
			//console.error('❌ Error al obtener refresh token:', error);
			return null;
		}
	},

	setRefreshToken: (token) => {
		try {
			localStorage.setItem('refreshToken', token);
		} catch (error) {
			//console.error('❌ Error al guardar refresh token:', error);
			return nulll;
		}
	},

	getUser: () => {
		try {
			const user = localStorage.getItem('user');
			return user ? JSON.parse(user) : null;
		} catch (error) {
			//console.error('❌ Error al obtener usuario:', error);
			return null;
		}
	},

	setUser: (user) => {
		try {
			localStorage.setItem('user', JSON.stringify(user));
		} catch (error) {
			//console.error('❌ Error al guardar usuario:', error);
			return null;
		}
	}
};

// Estado para evitar múltiples refresh simultáneos
let isRefreshing = false;
let refreshSubscribers = [];

// ✅ Sistema de suscripción para reintentos
const onTokenRefreshed = (token) => {
  	refreshSubscribers.forEach(callback => callback(token));
  	refreshSubscribers = [];
};

const addRefreshSubscriber = (callback) => {
  	refreshSubscribers.push(callback);
};

// ✅ Función de refresh token separada
const refreshAuthToken = async () => {
  	if (isRefreshing) {
    	//console.log('🔄 Refresh en progreso, esperando...');
    	return new Promise((resolve) => {
      		addRefreshSubscriber((token) => {
        		resolve(token);
      		});
    	});
  	}

	isRefreshing = true;
	const refreshToken = TokenManager.getRefreshToken();

	if (!refreshToken) {
		//console.log('❌ No hay refresh token disponible');
		isRefreshing = false;
		throw new Error('No refresh token available');
	}

  	try {
		//console.log('🔄 Intentando refresh token...');
		const response = await fetch(`${API_BASE_URL}/auth/jwt/refresh/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ refresh: refreshToken }),
		});

		if (!response.ok) {
			throw new Error(`Refresh failed with status: ${response.status}`);
		}

    	const tokens = await response.json();
    	//console.log('✅ Refresh token exitoso');
    
    	TokenManager.setToken(tokens.access);
    	onTokenRefreshed(tokens.access);
    
    	return tokens.access;
  	} catch (error) {
    	//console.error('❌ Error en refresh token:', error);
    	TokenManager.removeToken();
    	window.location.href = '/login';
    	throw new Error('Sesión expirada');
  	} finally {
    		isRefreshing = false;
  	}
};

// 🔄 FUNCIÓN PRINCIPAL MEJORADA: Maneja tanto JSON como Blobs (Excel)
export const authFetch = async (url, options = {}) => {
  	let token = TokenManager.getToken();
	
	// 🔥 CORRECCIÓN CRÍTICA: Verificar si la URL ya es completa
	let fullUrl;
	if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) {
		// Si ya es una URL completa, usarla tal cual
		fullUrl = url;
		//console.log('🌐 URL completa proporcionada:', url);
	} else {
		// Si es una ruta relativa, agregar el base URL
		//const cleanUrl = url.startsWith('/') ? url : `/${url}`;
		fullUrl = `${API_BASE_URL}${url.startsWith('/') ? url : `/${url}`}`;
		//console.log('🌐 URL construida desde ruta:', fullUrl);
	}
  
  	//console.log(`🔗 Haciendo petición a: ${fullUrl}`);
  	//console.log(`🔑 Token para la petición:`, token ? '✅ Presente' : '❌ Ausente');

  	// ✅ CORREGIDO: No establecer Content-Type por defecto si es FormData
	const config = {
		...options,
		headers: {
			...options.headers,
		},
	};

  	// Solo agregar Content-Type si no es FormData y no se proporcionó uno
  	if (!config.headers['Content-Type'] && !(options.body instanceof FormData)) {
    		config.headers['Content-Type'] = 'application/json';
  	}

	if (token) {
		config.headers['Authorization'] = `JWT ${token}`;
	}

  	try {
    	// 🔥 CORREGIDO: Usar fullUrl en lugar de concatenar
    	const response = await fetch(fullUrl, config);
    
    	//console.log(`📡 Respuesta recibida: ${response.status} para ${url}`);
    	//console.log(`📄 Content-Type: ${response.headers.get('content-type')}`);

    	// Manejo de 401 (token expirado)
    	if (response.status === 401 && token) {
      		//console.log('🔄 Token expirado, intentando refresh...');
      
      		try {
        		const newToken = await refreshAuthToken();
        
        		// Reintentar la petición original con el nuevo token
        		config.headers['Authorization'] = `JWT ${newToken}`;
        		const retryResponse = await fetch(fullUrl, config);
        
        		//console.log('✅ Petición reintentada exitosamente después de refresh');
        		return await handleResponse(retryResponse, url);
			} catch (refreshError) {
				//console.error('❌ Error crítico en refresh:', refreshError);
				throw refreshError;
			}
    	}

    	return await handleResponse(response, url);

  	} catch (error) {
    	//console.error(`❌ Error en API [${url}]:`, error);
    
    	if (error.message === 'Sesión expirada') {
      		return Promise.reject(error);
    	}
    
    	if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
      		throw new Error('Error de conexión. Verifica tu conexión a internet.');
    	}
    
    	// 🔥 NUEVO: Manejo específico de error de URL
    	if (error.name === 'TypeError' && error.message.includes('Failed to parse URL')) {
      		//console.error('🚨 ERROR CRÍTICO DE URL:', {
        	//	urlOriginal: url,
        	//	fullUrlCalculada: fullUrl,
        	//	error: error.message
      		//});
      		throw new Error(`Error en la URL de la API: ${url}. Contacta al administrador.`);
    	}
    
    	throw error;
  	}
};


// 🔥 MANEJO DE RESPUESTAS MEJORADO: Soporta Blobs para Excel
const handleResponse = async (response, url) => {
	// Verificar el tipo de contenido
	const contentType = response.headers.get('content-type');
	//console.log(`📄 Content-Type de la respuesta: ${contentType}`);

	// 📁 DETECCIÓN DE ARCHIVOS EXCEL
	const isExcelFile = contentType && (
		contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
		contentType.includes('application/vnd.ms-excel') ||
		contentType.includes('application/octet-stream')
	);

	// 🗃️ DETECCIÓN DE PDF (si también los exportas)
	const isPDFFile = contentType && contentType.includes('application/pdf');

	// 📁 Si es un archivo para descargar
	if (isExcelFile || isPDFFile || response.headers.get('content-disposition')) {
		//console.log(`📥 Detectado archivo para descarga: ${isExcelFile ? 'Excel' : isPDFFile ? 'PDF' : 'Archivo'}`);
		
		if (!response.ok) {
			const errorText = await response.text();
			//console.error(`❌ Error al descargar archivo: ${errorText}`);
			throw new Error(`Error al descargar archivo: ${response.status} ${response.statusText}`);
		}

		// Descargar como blob
		const blob = await response.blob();
		
		// Intentar obtener el nombre del archivo del header content-disposition
		let filename = `export-${new Date().toISOString().split('T')[0]}.${isExcelFile ? 'xlsx' : isPDFFile ? 'pdf' : 'bin'}`;
		const contentDisposition = response.headers.get('content-disposition');
		
		if (contentDisposition) {
			const match = contentDisposition.match(/filename="(.+)"/);
			if (match && match[1]) {
				filename = match[1];
			} else {
				const match2 = contentDisposition.match(/filename=([^;]+)/);
				if (match2 && match2[1]) {
					filename = match2[1];
				}
			}
		}
		
		//console.log(`📁 Archivo listo para descargar: ${filename} (${blob.size} bytes)`);
		
		// Crear URL para el blob y descargar automáticamente
		const blobUrl = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = blobUrl;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		
		// Limpiar
		setTimeout(() => {
			document.body.removeChild(a);
			window.URL.revokeObjectURL(blobUrl);
			//console.log('✅ Archivo descargado y recursos liberados');
		}, 100);
		
		return { 
			success: true, 
			filename: filename,
			blob: blob,
			type: isExcelFile ? 'excel' : isPDFFile ? 'pdf' : 'file'
		};
	}

	// 📝 MANEJO DE RESPUESTAS NORMALES (JSON)
	if (!response.ok) {
		let errorData;

		try {
			if (contentType && contentType.includes('application/json')) {
				errorData = await response.json();
			} else {
				const text = await response.text();
				errorData = { detail: text || `Error ${response.status}: ${response.statusText}` };
			}
		} catch (parseError) {
			//console.error('❌ Error parseando respuesta de error:', parseError);
			errorData = { detail: `Error ${response.status}: No se pudo leer la respuesta` };
		}

		const errorMessage = errorData.detail || errorData.error || 
					errorData.message || `Error ${response.status}: ${response.statusText}`;

		//console.error(`❌ Error en petición [${url}]:`, errorMessage);
		throw new Error(errorMessage);
	}

	// ✅ PARA RESPUESTAS EXITOSAS
	try {
		// Si es una respuesta 204 (No Content) o vacía, retornar null
		if (response.status === 204 || !contentType) {
			//console.log('✅ Petición exitosa (sin contenido)');
			return null;
		}

		// Si es JSON, parsear normalmente
		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			//console.log('✅ Petición exitosa (JSON):', data);
			return data;
		}

		// Si es texto plano, retornar el texto
		if (contentType && contentType.includes('text/')) {
			const text = await response.text();
			//console.log('✅ Petición exitosa (texto):', text.substring(0, 100) + '...');
			return text;
		}

		// Para otros tipos de contenido, retornar la respuesta
		//console.log('✅ Petición exitosa (contenido no-JSON)');
		return response;

	} catch (parseError) {
		//console.error('❌ Error parseando respuesta exitosa:', parseError);
		throw new Error('Error procesando la respuesta del servidor');
	}
};

// ✅ Función específica para FormData
export const authFetchFormData = async (url, formData, method = 'PATCH') => {
	const token = TokenManager.getToken();
	
	//console.log('📤 Enviando FormData:', {
	//	url,
	//	method,
	//	hasToken: !!token,
	//	formDataKeys: Array.from(formData.keys())
	//});

	const config = {
		method,
		headers: {
			'Authorization': token ? `JWT ${token}` : '',
			// ❌ IMPORTANTE: No establecer Content-Type para FormData
		},
		body: formData,
	};

  	return authFetch(url, config);
};

// ✅ Función específica para descargar archivos (wrapper para mayor claridad)
export const downloadFile = async (url, options = {}) => {
	//console.log('📥 Iniciando descarga de archivo desde:', url);
	
	// Forzar el tratamiento como descarga de archivo
	const config = {
		...options,
		// Podríamos agregar headers específicos si es necesario
	};
	
	return authFetch(url, config);
};

// ✅ Función de logout centralizada
export const handleLogout = (redirectToLogin = true) => {
	//console.log('🚪 Cerrando sesión...');
	TokenManager.removeToken();
	if (redirectToLogin) {
		window.location.href = '/login';
	}
};

// ✅ Exportar TokenManager y funciones auxiliares
export { TokenManager, refreshAuthToken };
